import { render, staticRenderFns } from "./pieChat.vue?vue&type=template&id=42b49844&"
import script from "./pieChat.vue?vue&type=script&lang=js&"
export * from "./pieChat.vue?vue&type=script&lang=js&"
import style0 from "./pieChat.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports